import { message } from 'antd';
import { Button, Collapse, FlexRow } from 'components';
import { getAccessToken } from 'helpers/tokenManager';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useRef, useState } from 'react';

const SuperadminAccessToken = () => {
  const { t } = useCustomTranslation();

  const [showAccessToken, setShowAccessToken] = useState(false);

  const formUrlWrapper = useRef<HTMLInputElement>();

  const copyToClipboard = () => {
    if (!formUrlWrapper) {
      return;
    }
    formUrlWrapper.current?.select();
    document.execCommand('copy');

    message.success(t('company.settings.orderSettings.urlCopySuccess'));
  };

  return (
    <div className="SuperadminAccessToken mb-1">
      <FlexRow right>
        <Button type="primary" onClick={() => setShowAccessToken(!showAccessToken)}>
          {t('dashboard:showAccessTokenButton')}
        </Button>
      </FlexRow>
      <Collapse isOpen={showAccessToken}>
        <div className="copy-to-clipboard" onClick={copyToClipboard}>
          <textarea ref={formUrlWrapper as any} value={getAccessToken()} readOnly />
        </div>
      </Collapse>
    </div>
  );
};

export default SuperadminAccessToken;
